import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-calendar-expandable-picker",
  templateUrl: "./calendar-expandable-picker.component.html",
  styleUrls: ["./calendar-expandable-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarExpandablePickerComponent implements OnInit {
  options = ["Options", "Start", "Duration", "Offset"];

  constructor() {}

  ngOnInit(): void {}
}
